export const BASE_PATH = "/";

export const PATHS = {
  BID_PAGE: `${BASE_PATH}`,
  BID2_PAGE: `${BASE_PATH}bid`,
  HOME_PAGE: `${BASE_PATH}home`,
  UP_NEXT_PAGE: `${BASE_PATH}up-next`,
  HISTORY_PAGE: `${BASE_PATH}history`,
  HISTORY_DETAIL_PAGE: `${BASE_PATH}history/:cp_id`,
  RESULTS_PAGE: `${BASE_PATH}results`,
  RESULTS_DETAIL_PAGE: `${BASE_PATH}results/:cp_id`,
  RULES_PAGE: `${BASE_PATH}rules`,
  ACCOUNT_PAGE: `${BASE_PATH}account`,
  LOGIN_PAGE: `${BASE_PATH}login`,
  QUESTIONS_PAGE: `${BASE_PATH}questions`,
  TERM_PAGE: `${BASE_PATH}terms`,
  POLICY_PAGE: "https://bitel.com.pe/politica/proteccion-de-datos",
  REGISTER_PAGE:
    "https://mi.bitel.com.pe/RegisterByEsport?urlCallback=https://subasta.bitel.com.pe",
  FORGOT_PASSWORD_PAGE: `${BASE_PATH}forgot-password`,
  FORGOT_PASSWORD_OTP_PAGE: `${BASE_PATH}forgot-password-otp`,
  VERIFY_OTP_PAGE: `${BASE_PATH}verify-otp`,
  DELIVERY_PAGE: `${BASE_PATH}delivery`,
  UNDEFINED_PAGE: `${BASE_PATH}*`,
  EVENT: `${BASE_PATH}event`,
  EVENT_2025: `${BASE_PATH}event-2025`,
  EVENT_WORLD_CUP_2026: `${BASE_PATH}event-world-cup-2026`,
};
